import { getLocalServerURL } from "./apiUrl";

function extractBannerImageName(value) {
  if (!value) return "";
  if (typeof value === "string") return value.trim();
  if (Array.isArray(value)) {
    for (const item of value) {
      const name = extractBannerImageName(item);
      if (name) return name;
    }
    return "";
  }
  if (typeof value === "object") {
    return extractBannerImageName(
      value.image || value.logo || value.url || value.path || value.src
    );
  }
  return "";
}

export function getBranchLogoFileName(branch) {
  if (!branch || typeof branch !== "object") return "";

  const candidates = [
    branch.publicPagesDate?.bannerImage,
    branch.invoiceData?.bannerImage,
    branch.reportPrintData?.bannerImage,
    branch.companyDetails?.bannerImage,
    branch.logo,
    branch.bannerImage
  ];

  for (const candidate of candidates) {
    const name = extractBannerImageName(candidate);
    if (name) return name;
  }
  return "";
}

export function getBranchLogoUrl(branch) {
  const fileName = getBranchLogoFileName(branch);
  if (!fileName) return "";
  if (
    fileName.startsWith("data:") ||
    fileName.startsWith("http://") ||
    fileName.startsWith("https://")
  ) {
    return fileName;
  }
  return `${getLocalServerURL()}/assets/layout/images/companies/${encodeURI(fileName).replace(/#/g, "%23")}`;
}

export function getClientInitials(name) {
  const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
}
